// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "select[data-v-2cb6df76]{border-radius:10px;height:35px;width:100%;text-align:center}select[data-v-2cb6df76]:focus{outline:none;border:1px solid #20b2aa}[data-v-2cb6df76]::placeholder{text-align:center}[data-v-2cb6df76]::-webkit-input-placeholder{text-align:center}[data-v-2cb6df76]:-moz-placeholder,[data-v-2cb6df76]::-moz-placeholder{text-align:center}[data-v-2cb6df76]:-ms-input-placeholder{text-align:center}", ""]);
// Exports
module.exports = exports;
